import React, { useState, useContext } from "react";
import { useHistory } from "react-router-dom";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import "react-datepicker/dist/react-datepicker.css";
import { Row, Col } from "react-bootstrap";
import { MdOutlineModeEditOutline, MdSupervisedUserCircle, MdAccountCircle } from "react-icons/md";

import Lead from "../../shared/Lead";
import * as API from "../../api";
import Loading from "../../shared/Loading";
import Select from "../../shared/Select";
import TextArea from "../../shared/TextArea";
import Patient from "../../shared/Patient";
import FieldError from "../../shared/FieldError";

const PatientRegistrationTask = ({ task, dispatch, isCall, formHandler }) => {
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  return (
    <>
      <h1>Patient Self Registered</h1>
      <div>
        This patient self-registered on { task.patient.registered_on }. Please contact the patient and schedule their initial appointment if they haven't already done so.
      </div>
    </>
  );
};

export default PatientRegistrationTask;
